'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/person/Multiple.tsx
import { jsx } from "react/jsx-runtime";
var MultiplePersonIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.99997 5C6.89541 5 5.99997 5.89543 5.99997 7C5.99997 8.10457 6.89541 9 7.99997 9C9.10454 9 9.99998 8.10457 9.99998 7C9.99998 5.89543 9.10454 5 7.99997 5ZM3.99997 7C3.99997 4.79086 5.79084 3 7.99997 3C10.2091 3 12 4.79086 12 7C12 9.20914 10.2091 11 7.99997 11C5.79084 11 3.99997 9.20914 3.99997 7ZM17 6C16.1715 6 15.5 6.67157 15.5 7.5C15.5 8.32843 16.1715 9 17 9C17.8284 9 18.5 8.32843 18.5 7.5C18.5 6.67157 17.8284 6 17 6ZM13.5 7.5C13.5 5.567 15.067 4 17 4C18.933 4 20.5 5.567 20.5 7.5C20.5 9.433 18.933 11 17 11C15.067 11 13.5 9.433 13.5 7.5ZM18.9682 14.6066C17.886 13.884 16.5717 13.8094 15.4456 14.3698L14.5546 12.5792C16.3248 11.6984 18.4026 11.8241 20.0788 12.9433C21.7623 14.0674 22.9452 16.12 23.1432 18.9297L23.2187 20H17.0001V18H21.0075C20.6719 16.3042 19.8665 15.2064 18.9682 14.6066ZM3.12658 19H12.8734C12.2633 15.5047 10.0063 14 7.99997 14C5.99363 14 3.73669 15.5047 3.12658 19ZM7.99997 12C11.4706 12 14.6399 14.8568 14.9975 19.9297L15.0729 21H0.927002L1.00245 19.9297C1.36004 14.8568 4.5293 12 7.99997 12Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/person/Rounded.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var PersonRoundedIcon = (props) => {
  return /* @__PURE__ */ jsx2(
    "svg",
    __spreadProps(__spreadValues({
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx2(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 14.2369 4.36336 16.2715 5.77673 17.7898C7.24771 16.0739 9.41739 15 12 15C14.5826 15 16.7523 16.0739 18.2233 17.7898C19.6366 16.2715 20.5 14.2369 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM17.1085 18.7943C15.917 17.3883 14.1507 16.5 12 16.5C9.84927 16.5 8.08297 17.3883 6.89147 18.7943C8.31373 19.8655 10.0821 20.5 12 20.5C13.9179 20.5 15.6863 19.8655 17.1085 18.7943ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 14.9741 20.7007 17.6456 18.6413 19.4763C16.8757 21.0458 14.5484 22 12 22C9.45163 22 7.12431 21.0458 5.35869 19.4763C3.29925 17.6456 2 14.9741 2 12ZM12 7.5C10.6193 7.5 9.5 8.61929 9.5 10C9.5 11.3807 10.6193 12.5 12 12.5C13.3807 12.5 14.5 11.3807 14.5 10C14.5 8.61929 13.3807 7.5 12 7.5ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/person/Single.tsx
import { jsx as jsx3, jsxs } from "react/jsx-runtime";
var SinglePerson = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx3(
        "path",
        {
          d: "M8.00065 7.33333C6.52789 7.33333 5.33398 6.13943 5.33398 4.66667C5.33398 3.19391 6.52789 2 8.00065 2C9.47341 2 10.6673 3.19391 10.6673 4.66667C10.6673 6.13943 9.47341 7.33333 8.00065 7.33333Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx3(
        "path",
        {
          d: "M2.00043 13.4662C2.25884 10.2844 4.84127 8.66675 7.98889 8.66675C11.1808 8.66675 13.8033 10.1955 13.9986 13.4667C14.0064 13.5971 13.9986 14.0001 13.4978 14.0001C11.0274 14.0001 7.35648 14.0001 2.485 14.0001C2.31781 14.0001 1.98636 13.6395 2.00043 13.4662Z",
          fill: "currentColor"
        }
      )
    ]
  })
);

export {
  MultiplePersonIcon,
  PersonRoundedIcon,
  SinglePerson
};
//# sourceMappingURL=chunk-32HI4BEU.mjs.map